module.exports = __webpack_public_path__ + "static/media/demo.9b9debcf.gif";